<template>
  <div class="page">
    <FacebookRelogin/>
  </div>
</template>

<script>
    import { Component, Vue } from 'vue-property-decorator';
    import FacebookRelogin from '@/components/FacebookRelogin.vue';

    @Component({
        components: {
            FacebookRelogin,
        },
    })
    export default class Login extends Vue {}
</script>

<style lang="scss">
  #loginNext {
    width: 250px;
  }
</style>
